var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKalmarLogoNewRound = function SvgKalmarLogoNewRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 30,
    transform: "rotate(-180 42 42)",
    fill: "#2C112D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.8 27.6H45.984s-1.052 3.847-3.402 6.995c-2.487 3.332-6.283 5.981-6.443 6.142 6.986 0 16.027 1.186 24.66-13.137h.002ZM36.139 27.612V40.75c-2.937 0-11.562-1.81-10.902-13.137M60.8 55.19H45.984s-1.052-3.846-3.402-6.994c-2.487-3.333-6.283-5.982-6.443-6.143 6.986 0 16.027-1.186 24.66 13.137h.002ZM36.138 55.178V42.04c-2.936 0-11.562 1.81-10.902 13.137",
    fill: "#fff"
  })));
};
export default SvgKalmarLogoNewRound;